import React from "react";
import { SmartPayPayment } from "../../components/SmartPay/Payment";
import { useParams, useSearchParams } from "react-router-dom";

export default function SmartPayPaymentPage() {
  const { checkoutToken } = useParams();
  const [searchParams] = useSearchParams();
  const paymentProfileId = searchParams.get('paymentProfileId');

  const handleError = async (data: any, error: any) => {
    let errorMsg;
    if ((typeof error === 'string' || error instanceof String ) && !error.startsWith('Error Message: {')){
      errorMsg = error;
    } else {
      try {
        const errorObj = JSON.parse(error.substring(15,error.length - 1)).message;
        errorMsg = `${errorObj?.errorDetails?.gatewayDescription} - ${errorObj?.errorDetails?.paymentProviderDescription}`;
      } catch (err) {
        console.log(`###${err}###`);
        console.log(`###${error}###`);
        errorMsg = error;
      }
    }
    //window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://payment_redirect?result=error&errorCode=${data}&errorMessage=${errorMsg}`;
    window.location.href = `/redirect.html?id=${process.env.REACT_APP_MOBILEAPP_ID}&result=error&errorCode=${data}&errorMessage=${errorMsg}`;
  }

  const handleSuccess = async (data: any) => {
    if (data.kind === "CALLBACK") {
      //window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://payment_redirect?result=success`;
      //window.location.href = `${process.env.REACT_APP_JPM_REDIRECT_URL}?result=success`;
      //window.location.href = `/smartpay/redirect?result=success`;
      //window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://payment_redirect?result=success`;
      window.location.href = `/redirect.html?id=${process.env.REACT_APP_MOBILEAPP_ID}&result=success`;
    }
  }

  const sdkUrl = process.env.REACT_APP_JPM_CHECKOUT_SDK_URL;

  return (
    <div>
      <SmartPayPayment
        checkoutToken={checkoutToken}
        onError={handleError}
        onSuccess={handleSuccess}
        sdkUrl={sdkUrl}
        paymentProfileId={paymentProfileId}
      />
    </div>
  )
}
